export default __webpack_public_path__ + "static/media/icon-link.436183a1.svg";